import { useContext } from 'react';
import { DynamicTableContext, DynamicTableContextValue } from '../context/DynamicTableContext';

type UseDynamicTableReturnValue = DynamicTableContextValue;

const useDynamicTable = (): UseDynamicTableReturnValue => {
  const context = useContext(DynamicTableContext);

  if (!context) {
    throw new Error('useDynamicTable must be used within a DynamicTableProvider');
  }

  return context;
};

export default useDynamicTable;
